import React from 'react';

import TranscriptOverlayButton from '../transcript-overlay-button';
import VideoButtons from '../video-buttons';

import styles from './styles.module.less';

export default ({
  // collapsed = only icons are showing, text is hidden
  // collapsible = can change state into collapsed state (false = force uncollapsed)
  // hidden = this component renders nothing
  isCollapsible = false,
  isHidden,
  startCollapsed = false,
}) => {
  return (
    <VideoButtons
      startCollapsed={startCollapsed}
      isCollapsible={isCollapsible}
      isHidden={isHidden}
    >
      {/* VideoButtons uses the Function As Child Component (FaCC) pattern */}

      {({ isCollapsed }) => (
        <div className={styles.transcriptOverlay}>
          <TranscriptOverlayButton isCollapsed={isCollapsed} />
        </div>
      )}
    </VideoButtons>
  );
};
